// Dependencies imports
import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbar } from '@material-ui/data-grid';
import { API } from "aws-amplify";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/styles';
import { Link, useNavigate } from "react-router-dom";

// Local imports

import { awsSignIn, authData } from "../../redux/auth/authSlice";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";

// Styles imports
import Assesg from './AssesmentGrid.module.scss';

// Data for User Stats Grid 
const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        editable: true
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        editable: true
    },
    {
        field: 'enrolled',
        headerName: 'Enrolled on',
        width: 300,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        editable: true
    }
];

const useStyles = makeStyles({
    root: {
        '& .super-app-theme--header': {
            background: config.main_color_1,
            fontSize: "16px",
            color: 'rgb(255,255,255)',
            fontFamily: "nunito"
        },
    },
    ".MuiDataGrid-root": {
        fontSize: "14px",
        fontFamily: "nunito",
        fontWeight: 400,
        color: "black",
        cursor: "pointer"
    }
});

const columns1 = [
    { dataField: 'id', text: 'Id' },
    { dataField: 'name', text: 'Name' },
    { dataField: 'animal', text: 'Animal' },
]

const data = [
    { id: 1, name: 'George', animal: 'Monkey' },
    { id: 2, name: 'Jeffrey', animal: 'Giraffe' },
    { id: 3, name: 'Alice', animal: 'Giraffe' },
    { id: 4, name: 'Alice', animal: 'Tiger' }
]

// Start of Instructor Grid Component
const UserStatsGrid = (props) => {
    let { userData, selectionModel, setSelectionModel } = props;
    const classes = useStyles();
    // const [loading, setLoading] = useState(true);
    // const [userData, setUserData] = useState([]);



    let userDetails = useSelector(authData);
    let navigate = useNavigate();
    const dispatch = useDispatch();

    // function for toolbar options above datagrid
    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ display: "flex", justifyContent: "flex-end" }}>
                <GridToolbar />
            </GridToolbarContainer>
        );
    }
    //

    // Useeffect for faculty details api
    useEffect(() => {
        // getFaculty();
        return () => { };
    }, []);

    // Api call to get faculty details
    async function getFaculty() {
        // setLoading(true);
        const bodyParam = {
            body: {
                oid: config.aws_org_id,
                bpid: userDetails.curprgcou.bpid
            },
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };
        try {
            console.log(bodyParam.body);
            const users = await API.post(
                config.aws_cloud_logic_custom_name,
                Constants.GET_PROGRAM_BATCH_REPORT,
                bodyParam
            );
            console.log("users", users);
            convertData(users);

        }
        catch (error) {
            console.error(error);
        }
    }

    function convertData(data) {
        let temp = [];
        for (let i = 0; i < data.length; i++) {
            let obj = {};
            obj.id = i;
            obj.name = data[i].UNAME;
            obj.email = data[i].EMAILID;
            obj.userrole = data[i].UR;
            if (obj.userrole === "User") {
                temp.push(obj);
            }
        }
        // setUserData(temp);
        // setLoading(false);
    }

    const handleCellClick = (param, event) => {
     
        console.log(param.row);
        let sdata = { ...userDetails };
        sdata.selbatchuser = { ...param.row };
        let temp = [...sdata.breadcrumb];
        console.log(sdata.selbatchuser)

        
        temp[3] = {
            name: sdata.selbatchuser.name ,
            path: "/userprogress"
        };

        sdata.breadcrumb = temp;
        dispatch(awsSignIn(sdata));

        navigate("/userprogress");
        // console.log(event);
    }


    return (
        <div style={{ height: 400, width: '100%' }}>
            <div style={{ height: 400, width: '100%' }}>
                <DataGrid
                    rows={userData}
                    columns={columns}
                    checkboxSelection
                    disableSelectionOnClick
                    components={{ Toolbar: CustomToolbar }}
                    onRowSelected={e => console.log(e)}
                    onSelectionModelChange={(newSelection) => {
                        console.log(newSelection);
                        setSelectionModel(newSelection);
                    }}
                    selectionModel={selectionModel}
                    onCellClick={handleCellClick}
                    className={classes['.MuiDataGrid-root']}
                />
            </div>

        </div >
    );
}

export default UserStatsGrid;